var styles = {"box":"NavButton_box_rorxa_1","v2":"NavButton_v2_rorxa_22","active":"NavButton_active_rorxa_22","text":"NavButton_text_rorxa_25","bg":"NavButton_bg_rorxa_41","icon":"NavButton_icon_rorxa_44","star-1":"NavButton_star-1_rorxa_66","star-2":"NavButton_star-2_rorxa_72","star-3":"NavButton_star-3_rorxa_78"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
